<template>
  <div>
    <appoveOrRejectModal  v-if="openApprove" @hideMe="hideMe" @updatepetition="updatepetition":actionType="actionType" :caseDetails="caseDetails"/>
   
    <vs-popup v-else-if="isEverifier"  class="holamundo main-popup" :title="checkProperty(caseDetails, 'petitionerDetails', 'eVerifyClientId') ? 'I-9 E-Verify': 'Add I-9 E-Verify Client ID'" :active.sync="isEverifier">
      <eVerify   @hideMe="hideMe" @updatepetition="updatepetition" :caseDetails="caseDetails"/>
    </vs-popup>
    
  </div>
</template>
<script>
import eVerify from "@/views/i-9Module/actionsFlow/actionsComponents/eVerify.vue"
import appoveOrRejectModal from "@/views/i-9Module/actionsFlow/actionsComponents/appoveOrRejectModal.vue"
export default {
  inject: ["parentValidator"],
  created() {
      this.$validator = this.parentValidator;
  },
  components: {
    appoveOrRejectModal,
    eVerify
  },
  data() {
    return {
      actionType:null,
      openApprove:false,
      isEverifier:false,
    }
  },
  methods: {
    openApproveOrRejectModal(type){
      this.actionType = null
      this.isEverifier = false;
      if(type=='E-VERIFY'){
        this.isEverifier=true
      }else{
        this.actionType = type
        this.openApprove = true;
      }
    },
    updatepetition(){
      this.isEverifier=false
     setTimeout(()=>{
      this.$emit("updatepetition", "Case Details");
     }, 1000)
      
     
    },
    hideMe(){
      this.isEverifier=false
      this.openApprove = false;
      this.actionType = null
    }
  },
  mounted(){
    
  },
  computed:{

  },
  props: {
      caseDetails: {
        type: Object,
        default: null,
      },
    },
}
</script>